exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".the-card {\n    max-width: 300px;\n    max-height: 150px;\n    min-height: 150px;\n    margin: 10px; \n    text-align:left;\n  }\n\n.card-content{\n    max-height: 50px;\n    min-height: 50px;    \n}\n\n.card-container{\n    display: inline-block;\n}\n\n.card-buttons{\n    text-align:center;    \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/card-template/card-template.component.css
// module id = ../../../../../src/app/card-template/card-template.component.css
// module chunks = main